import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import DocumentVisualizationMasterModalPage from '../../../containers/masters/DocumentVisualization/DocumentVisualizationMasterModalPage'
import MapSectionsMasters from '../../../util/map-sections-masters'

class DocumentVisualizationMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        page: 1,
        orderBy: ''
      }
    }
  }

  componentDidMount () {
    this.props.actions.fetchDocumentTypeUseCombo()
    this.props.actions.fetchSearchDossierSubType()
    this.props.actions.fetchDocumentVisualizations()
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchDocumentVisualizations({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchDocumentVisualizations({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  searchDocumentVisualizationList () {
    this.props.actions.fetchDocumentVisualizations({ ...this.props.filter, ...this.state.filter })
  }

  render () {
    const {
      t, documentVisualizations, pagesCount, documentVisualizationsCount, filter,
      filter: { page },
      actions: { deleteDocumentVisualization, openDocumentVisualizationModal, fetchDocumentVisualizations },
      combos: { dossierSubtypesCombo, documentTypeUseCombo }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'documentVisualizationMasterPage' })
    const tKey = 'MASTERS.DOCUMENT_VISUALIZATION.'
    const editTooltip = (<Tooltip id="editTooltip">{t('MASTERS.EDIT')}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('MASTERS.DELETE')}</Tooltip>)

    return (
      <div id='documentVisualizationMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button
              className="_Btn new"
              onClick={() => openDocumentVisualizationModal(null)}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer' + (this.state.maxiTable ? ' maxiTable' : '')}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(documentVisualizations.length !== 0) &&
                <Table className="editable-table" hover responsive>
                  <thead>
                    <tr>
                      <th onClick={() => { this.changeOrder('originDossierSubTypeId') }}>
                        {t(`${tKey}ORIGIN_SUBTYPE`)}
                        <i className={this.getSortIcon('originDossierSubTypeId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('destDossierSubTypeId') }}>
                        {t(`${tKey}DESTINY_SUBTYPE`)}
                        <i className={this.getSortIcon('destDossierSubTypeId')} />
                      </th>
                      <th onClick={() => { this.changeOrder('documentTypeUseId') }}>
                        {t(`${tKey}TYPE_USE`)}
                        <i className={this.getSortIcon('documentTypeUseId')} />
                      </th>
                      <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentVisualizations && documentVisualizations.map((documentVisualization, idx) => (
                      <tr key={idx} className={documentVisualization.isDeleted ? 'is-deleted' : ''}>
                        <td>{dossierSubtypesCombo && dossierSubtypesCombo.find(x => x.id === documentVisualization.originDossierSubTypeId)?.value }</td>
                        <td>{dossierSubtypesCombo && dossierSubtypesCombo.find(x => x.id === documentVisualization.destDossierSubTypeId)?.value }</td>
                        <td>{documentTypeUseCombo && documentTypeUseCombo.find(x => x.id === documentVisualization.documentTypeUseId)?.value }</td>
                        <td className='actions'>
                          {
                            <div>
                              <OverlayTrigger placement="left" overlay={editTooltip}>
                                <a className='_Btn accept stk o-icn ' onClick={() => openDocumentVisualizationModal(documentVisualization)}>
                                  <i className="iDocIcon-edit" />
                                </a>
                              </OverlayTrigger>
                              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                <a className='_Btn cancel stk o-icn ' onClick={() => deleteDocumentVisualization(documentVisualization.documentVisualizationId)}>
                                  <i className="iDocIcon-delete-forever" />
                                </a>
                              </OverlayTrigger>
                            </div>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }

              {(documentVisualizations === null || documentVisualizations === undefined || documentVisualizations.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_finance"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={documentVisualizationsCount}
                    onSelectAction={(value) => fetchDocumentVisualizations({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <DocumentVisualizationMasterModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'documentVisualizationMaster'
})(DocumentVisualizationMaster)
